import { ArrowChevronDownIcon } from '@tableau/icons/ArrowChevronDownIcon';
import { ArrowChevronUpIcon } from '@tableau/icons/ArrowChevronUpIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { expandedRowFocus } from './BridgeMultiPoolTableEntryPool';

export type ExpandPoolButtonProps = Readonly<{
  isExpanded: boolean;
  setExpanded: (expand: boolean) => void;
  isDisabled: boolean;
}>;

export function ExpandPoolButton(props: ExpandPoolButtonProps) {
  const focusHighlight = props.isExpanded ? expandedRowFocus : '';
  return (
    <td className={`tb-data-grid-separator-row ${focusHighlight}`}>
      <span className={'tb-data-grid-icon tb-padded-left-large'} data-tb-test-id={'pool-expand-icon'}>
        <ButtonWidget
          buttonType={ButtonType.IconOutline}
          testId={'expand-pool-button'}
          onClick={() => props.setExpanded(!props.isExpanded)}
          disabled={props.isDisabled}
        >
          {props.isExpanded ?
            <ArrowChevronUpIcon size={14} alt={Messages.collapse()} />
            :
            <ArrowChevronDownIcon size={14} alt={Messages.expand()} />
          }
        </ButtonWidget>
      </span>
    </td>
  );
}
